module.exports = __webpack_public_path__ + "static/level1-8fd56f6c3b07f5c71d36fd32ba6bf401.png";